import React from 'react';
import { Drawer, Descriptions, Table, Empty, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { AuditLogEntry } from '../../../services/auditLogApi';

interface FieldChangeRow {
  field: string;
  before: string;
  after: string;
}

const fmtValue = (v: unknown): string => {
  if (v === null || v === undefined) return '(空)';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

interface AuditLogDetailDrawerProps {
  entry: AuditLogEntry | null;
  onClose: () => void;
}

const AuditLogDetailDrawer: React.FC<AuditLogDetailDrawerProps> = ({ entry, onClose }) => {
  const changeColumns: ColumnsType<FieldChangeRow> = [
    { title: '欄位', dataIndex: 'field', key: 'field', width: 160 },
    { title: '改前', dataIndex: 'before', key: 'before' },
    { title: '改後', dataIndex: 'after', key: 'after' },
  ];

  const changeRows: FieldChangeRow[] = entry?.field_changes
    ? Object.entries(entry.field_changes).map(([field, change]) => ({
        field,
        before: fmtValue(change?.before),
        after: fmtValue(change?.after),
      }))
    : [];

  return (
    <Drawer
      title="稽核記錄明細"
      open={!!entry}
      onClose={onClose}
      width={640}
      destroyOnClose
    >
      {entry && (
        <>
          <Descriptions column={1} bordered size="small" style={{ marginBottom: 24 }}>
            <Descriptions.Item label="時間">{new Date(entry.occurred_at).toLocaleString('zh-TW')}</Descriptions.Item>
            <Descriptions.Item label="使用者">{entry.user_id}</Descriptions.Item>
            <Descriptions.Item label="表單代碼">{entry.form_id}</Descriptions.Item>
            <Descriptions.Item label="單號">{entry.doc_key}</Descriptions.Item>
            <Descriptions.Item label="動作">{entry.action}</Descriptions.Item>
            <Descriptions.Item label="IP">{entry.ip || '-'}</Descriptions.Item>
            <Descriptions.Item label="Session">{entry.session_id || '-'}</Descriptions.Item>
          </Descriptions>

          <Typography.Title level={5}>欄位異動（改前 / 改後）</Typography.Title>
          {changeRows.length > 0 ? (
            <Table<FieldChangeRow>
              rowKey="field"
              columns={changeColumns}
              dataSource={changeRows}
              pagination={false}
              size="small"
              style={{ marginBottom: 24 }}
            />
          ) : (
            <Empty description="無欄位異動記錄" style={{ marginBottom: 24 }} />
          )}

          <Typography.Title level={5}>完整快照 (full_snapshot)</Typography.Title>
          {entry.full_snapshot ? (
            <pre style={{
              background: '#f5f5f5', padding: 12, borderRadius: 4,
              maxHeight: 400, overflow: 'auto', fontSize: 12,
            }}>
              {JSON.stringify(entry.full_snapshot, null, 2)}
            </pre>
          ) : (
            <Empty description="無快照記錄" />
          )}
        </>
      )}
    </Drawer>
  );
};

export default AuditLogDetailDrawer;
